module.exports = __webpack_public_path__ + "static/media/oman-map.61dcc402.png";